import React from 'react';
import { Table } from 'semantic-ui-react';
import range from 'lodash/range';
import {
    Header, Cell, renderPrice, EmptyCell, Title
} from '../components';
import usePrint from '+/hooks/usePrint';
import Dimmer from '+/Dimmer';
import { PrintDate } from '../../../shared/components/PrintDate';

const styles = {
    root: {
        padding: '15px',
        fontWeight: 'bold'
    }

};

const ColonyMatrix = props => {

    const { data, isLoading, matrixType } = props;

    const { ref, Trigger } = usePrint();

    if (!data || isLoading) return <Dimmer message='Fetching matrix, this can take up to 60 seconds' />;

    return (
        <div ref={ref} style={styles.root} className='print landscape'>
            <div>
                <Trigger />
            </div>

            <Title data={Object.values(data)} title='Colony'/>
            <PrintDate isForPDF={false}/>
            <Table celled compact>
                <Table.Header>
                    <Table.Row>
                        <Header colSpan='100' content='East View 057-' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='C1' />
                        <Header colSpan='2' content='B' />
                        <Header colSpan='2' content='B' />
                        <Header colSpan='2' content='Al' />
                        <Header colSpan='2' content='B2' />
                        <Header colSpan='2' content='C2' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='3 Bedroom' />
                        <Header colSpan='2' content='2 Bedroom' />
                        <Header colSpan='2' content='2 Bedroom' />
                        <Header colSpan='2' content='1 Bedroom' />
                        <Header colSpan='2' content='2 Bedroom' />
                        <Header colSpan='2' content='3 Bedroom' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='1260 sq ft' />
                        <Header colSpan='2' content='970 sq ft' />
                        <Header colSpan='2' content='970 sq ft' />
                        <Header colSpan='2' content='830 sq ft' />
                        <Header colSpan='2' content='1085 sq ft' />
                        <Header colSpan='2' content='1315 sq ft' />
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {
                        range(8, 1, -1)
                            .map(n => n.toLocaleString('en-US', {
                                minimumIntegerDigits: 2,
                                useGrouping: false
                            }))
                            .map(floor => (
                                <Table.Row key={floor}>
                                    {
                                        range(4, 10)
                                            .map(n => n.toLocaleString('en-US', {
                                                minimumIntegerDigits: 2,
                                                useGrouping: false
                                            }))
                                            .map(unit_num => (

                                                <Cell
                                                    key={unit_num}
                                                    unit={`${floor}${unit_num}`}
                                                    price={renderPrice(data[`057-${floor}${unit_num}`], matrixType)}
                                                    status={data[`057-${floor}${unit_num}`].status}
                                                />
                                            ))
                                    }
                                </Table.Row>
                            ))
                    }

                    <Table.Row>
                        <Cell unit={'0104'} price={renderPrice(data['057-0104'], matrixType)} status={data['057-0104'].status}/>
                        <Cell unit={'0105'} price={renderPrice(data['057-0105'], matrixType)} status={data['057-0105'].status}/>
                        <Cell unit={'0106'} price={renderPrice(data['057-0106'], matrixType)} status={data['057-0106'].status}/>
                        <Cell unit={'0107'} price={renderPrice(data['057-0107'], matrixType)} status={data['057-0107'].status}/>
                        <Header textAlign='center' colSpan='2' content='1 Bedroom AS'/>
                        <Table.Cell />
                        <Table.Cell />
                    </Table.Row>
                    <Table.Row>
                        <EmptyCell count={4} />
                        <Header textAlign='center' colSpan='2' content='815 sq ft' />
                        <EmptyCell />
                    </Table.Row>
                    <Table.Row>
                        <EmptyCell count={4} />
                        <Cell unit={'0108'} price={renderPrice(data['057-0108'], matrixType)} status={data['057-0108'].status}/>
                        <EmptyCell />
                    </Table.Row>
                </Table.Body>
            </Table>

            <div className='pagebreak' />
            <div className='printspace' />

            <Title title='Colony' />
            <PrintDate isForPDF={false}/>
            <Table celled compact>
                <Table.Header>
                    <Table.Row>
                        <Header colSpan='100' content='West View 057-' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='B' />
                        <Header colSpan='2' content='B' />
                        <Header colSpan='2' content='B' />
                        <Header colSpan='2' content='B3' />
                        <Header colSpan='2' content='B' />
                        <Header colSpan='2' content='B' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='2 Bedroom' />
                        <Header colSpan='2' content='2 Bedroom' />
                        <Header colSpan='2' content='2 Bedroom' />
                        <Header colSpan='2' content='2 Bedroom' />
                        <Header colSpan='2' content='2 Bedroom' />
                        <Header colSpan='2' content='2 Bedroom' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='970 sq ft' />
                        <Header colSpan='2' content='970 sq ft' />
                        <Header colSpan='2' content='970 sq ft' />
                        <Header colSpan='2' content='1140 sq ft' />
                        <Header colSpan='2' content='1010 sq ft' />
                        <Header colSpan='2' content='970 sq ft' />
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {
                        range(8, 1, -1)
                            .map(n => n.toLocaleString('en-US', {
                                minimumIntegerDigits: 2,
                                useGrouping: false
                            }))
                            .map(floor => (
                                <Table.Row key={floor}>
                                    {
                                        [3, 2, 1, 12, 11, 10]
                                            .map(n => n.toLocaleString('en-US', {
                                                minimumIntegerDigits: 2,
                                                useGrouping: false
                                            }))
                                            .map(unit_num => (
                                                <Cell
                                                    key={unit_num}
                                                    unit={`${floor}${unit_num}`}
                                                    price={renderPrice(data[`057-${floor}${unit_num}`], matrixType)}
                                                    status={data[`057-${floor}${unit_num}`].status}
                                                />
                                            ))
                                    }
                                </Table.Row>
                            ))
                    }

                    <Table.Row>
                        <Cell unit={'0103'} price={renderPrice(data['057-0103'], matrixType)}status={data['057-0103'].status}/>
                        <Cell unit={'0102'} price={renderPrice(data['057-0102'], matrixType)}status={data['057-0102'].status}/>
                        <Cell unit={'0101'} price={renderPrice(data['057-0101'], matrixType)} status={data['057-0101'].status}/>
                        <EmptyCell count={3} />
                    </Table.Row>

                </Table.Body>
            </Table>

        </div>
    );


};

export default ColonyMatrix;
